import { createAsyncThunk } from '@reduxjs/toolkit'
import { taskTrackerApi } from '../../api/taskTracker.api'
import type { TaskTrackerBoardStickerFilter } from '../domain.types'
import { getErrorMessage } from '../shared/thunk.utils'

export type FetchBoardKanbanPayload = {
  boardId: number
  stickerFilters: TaskTrackerBoardStickerFilter[]
  isCompleted?: boolean
  isInitialLoad: boolean
}

export const fetchBoardKanbanThunk = createAsyncThunk(
  'taskTracker/fetchBoardKanban',
  async (payload: FetchBoardKanbanPayload, { rejectWithValue }) => {
    try {
      const details = await taskTrackerApi.getBoard(payload.boardId, {
        stickerFilters:
          payload.stickerFilters.length > 0
            ? payload.stickerFilters
            : undefined,
        isCompleted: payload.isCompleted,
      })
      return { ...payload, details }
    } catch (error: unknown) {
      return rejectWithValue({
        boardId: payload.boardId,
        isInitialLoad: payload.isInitialLoad,
        error: getErrorMessage(error, 'Не удалось загрузить доску'),
      })
    }
  },
)
